var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { classNames } from "@bookingcom/bui-core/utilities/classNames";
import CloseIcon from "@bookingcom/bui-assets-react/streamline/CloseIcon";
import Icon from "../Icon/index.js";
import Text from "../Text/index.js";
import Actionable from "../Actionable/index.js";
import styles from "@bookingcom/bui-core/css/Badge.module.css";
var Badge = function (props) {
    var variant = props.variant, alternative = props.alternative, text = props.text, icon = props.icon, ariaLabel = props.ariaLabel, className = props.className, attributes = props.attributes, onAfterClose = props.onAfterClose, closeAriaLabel = props.closeAriaLabel, shown = props.shown, children = props.children, mixin = props.mixin;
    var _a = React.useState(true), shownState = _a[0], setShown = _a[1];
    var rootClassName = classNames(styles.root, className, alternative && styles["root--alt"], variant && styles["root--variant-".concat(variant)], icon && !text && !children && styles["root--icon-only"]);
    var isControlled = typeof shown === "boolean";
    var shouldRender = isControlled ? shown : shownState;
    if (!shouldRender)
        return null;
    var handleClose = function () {
        if (!isControlled)
            setShown(false);
        if (onAfterClose)
            onAfterClose();
    };
    return (React.createElement(Text, { variant: "small_1", tagName: "span", className: rootClassName, attributes: __assign(__assign({}, attributes), { "aria-label": ariaLabel }), mixin: mixin },
        icon && React.createElement(Icon, { svg: icon, size: "smaller" }),
        (text || children) && (React.createElement("span", { className: styles.text }, text || children)),
        onAfterClose && closeAriaLabel && (React.createElement(Actionable, { onClick: handleClose, className: styles["close-icon"], attributes: { "aria-label": closeAriaLabel } },
            React.createElement(Icon, { svg: CloseIcon, size: "smallest" })))));
};
export default Badge;
